import { Link } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Logo from "../logo.png"
import '../index.css'
import { FaFacebookF, FaYoutube, FaInstagram, FaLinkedinIn, FaHome, FaEnvelope, FaWhatsapp, FaPhone } from "react-icons/fa";
import MobileSidebar from "./MobileSidebar";

function Footer() {
  return (
    <footer className="footer-mainbg text-white pt-5 pb-3">

      <MobileSidebar />
      <div className="container-fluid pb-3">
        <div className="row gy-4">
          {/* Logo + About */}
          <div className="col-md-3">
            <Link className="navbar-brand d-flex align-items-center" to="/">
              <img src={Logo} alt="logo" className="footer-logo me-2" />
            </Link>

            <p className="small mt-3">
              At SOLAR CLUB BHARAT, we combine precision and innovation to deliver high-quality engineering solutions. Trusted by clients, we turn ideas into reliable, lasting structures.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-md-3 col-sm-6 col-6">
            <h4 className="fw-bold mb-3">Quick Links</h4>
            <div className="divider" />
            <ul className="list-unstyled footer-links">
              <li><Link to="/" className="footer-link">Home</Link></li>
              <li><Link to="/services" className="footer-link">Services</Link></li>
              <li><Link to="/about" className="footer-link">About</Link></li>
              <li><Link to="/contact" className="footer-link">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="col-md-3 col-sm-6 col-6">
            <h4 className="fw-bold mb-3">Services</h4>
            <div className="divider" />
            <ul className="list-unstyled footer-links">
              <li><Link to="/customer" className="footer-link">Services</Link></li>
              <li><Link to="/faq" className="footer-link">FAQ</Link></li>
              {/* <li><Link to="/documents" className="footer-link">Documents</Link></li> */}
            </ul>
          </div>

          {/* Social Media */}
          <div className="col-md-3">
            <h4 className="fw-bold mb-3">Follow Us</h4>
            <div className="divider" />
            <div className="d-flex gap-3">
              <a href="/" className="social-icon home"><FaHome /></a>
              {/* <a href="" className="social-icon envelope"><FaEnvelope /></a> */}
              <a href="https://wa.me/919573487504" className="social-icon whatsapp"><FaWhatsapp /></a>
              <a href="tel:919573487504" className="social-icon phone">
                <FaPhone />
              </a>
            </div>

            <div className="d-flex gap-3 mt-3">
              <a href="https://www.facebook.com/p/Swastik-Engineers-100068248691310/" className="social-icon facebook"><FaFacebookF /></a>
              <a href="https://www.youtube.com/@swastikengineers7705" className="social-icon youtube">
                <FaYoutube />
              </a>
              <a href="https://www.instagram.com/swastikengineers01/" className="social-icon instagram"><FaInstagram /></a>
              <a href="https://www.linkedin.com/in/manish-sharma-a01b9585?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" className="social-icon linkedin"><FaLinkedinIn /></a>
            </div>
          </div>
        </div>

        <hr className="mt-4 mb-3" />

        <div className="text-center small pb-5">
          © {new Date().getFullYear()} <strong>SOLAR CLUB BHARAT</strong>. All Rights Reserved.
        </div>
      </div>
      {/* <button
  onClick={() => window.location.href = "tel:+919573487504"}
  style={{
    position: "fixed",
    bottom: "20px",       // screen ke niche
    right: "20px",        // right edge se door
    width: "50px",
    height: "50px",
    backgroundColor: "#28a745",
    color: "white",
    border: "none",
    borderRadius: "50%",  // perfectly circular
    fontSize: "24px",
    cursor: "pointer",
    zIndex: 1000,
    boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }}
  title="Call Now" // hover pe dikhega
>
  📞
</button> */}
    </footer>
  );
}

export default Footer;
